/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

export default {
    'searchList': {
        'searchTxt': [
            {
                'name': '客户订单号',
                'value': 'customerOrderNo',
                'type': 'input',
                'unfold': true,
                'span': 4
            },
            {
                'name': '创建时间',
                'value': 'searchTime',
                'type': 'time',
                'unfold': true,
                'timeNum': 3,
                'span': 6,
                'startPlaceholder': '创建开始时间',
                'endPlaceholder': '创建结束时间'
            },
            {
                name: '上传状态',
                value: 'receiptStatus',
                type: 'select',
                span: 4,
                unfold: true,
                optionNum: 'SYS_TMS_UPLOAD_STATUS',
                options: []
            },
            {
                'name': '运输单状态',
                'value': 'transportStatus',
                'type': 'select',
                'unfold': true,
                'span': 4,
                'optionNum': 'SIGN_STATUS',
                'options': []
            },
            {
                'name': '签收类型',
                'value': 'deliveredVerifyFlag',
                'type': 'select',
                'optionNum': 'DELIVERED_VERIFY_FLAG',
                'unfold': true,
                'span': 3,
                'options': []
            }
        ],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '运输单号',
                'prop': 'taskNo',
                'width': '192px',
                'sort': true
            },
            {
                'label': '客户订单号',
                'prop': 'customerOrderNo',
                'width': '192px',
                'sort': true
            },
            {
                'label': '发车单号',
                'prop': 'dispatchNo',
                'width': '180px',
                'sort': true
            },
            {
                'label': '客户',
                'prop': 'customerName',
                'width': '200px',
                'sort': true
            },
            {
                'label': '合同编号',
                'prop': 'contractNo',
                'width': '160px',
                'sort': true
            },
            {
                'label': '是否完好',
                'prop': 'signIsFullText',
                'width': '120px',
                'sort': true
            },
            {
                'label': '集配单号',
                'prop': 'collectNo',
                'width': '170px',
                'sort': true
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'width': '180px',
                'sort': true
            },
            {
                'label': '附件',
                'prop': 'files',
                'type': 'photos',
                'ifHas': 'otp04050004',
                'width': '120px',
                'sort': true
            },
            {
                'label': '回单印鉴',
                'prop': 'abc',
                'type': 'detail',
                'buttonName': '印鉴',
                'emitEvent': 'seal',
                'width': '120px',
                'sort': true
            },
            {
                'label': '上传状态',
                'prop': 'receiptStatusText',
                'width': '120px',
                'sort': true
            },
            {
                'label': '签收状态',
                'prop': 'signStatusText',
                'optionNum': 'SIGN_STATUS',
                'width': '120px',
                'sort': true
            },
            {
                'label': '签收人',
                'prop': 'signContact',
                'width': '160px',
                'sort': true
            },
            {
                'label': '签收时间',
                'prop': 'signTime',
                'width': '182px',
                'sort': true
            },
            {
                'label': '逾期明细',
                'type': 'detail',
                'width': '140px',
                'sort': true
            },
            {
                'label': '项目分类',
                'prop': 'projectClassifyText',
                'width': '140px',
                'sort': true
            },
            {
                'label': '要求回单时间',
                'prop': 'requestFileDate',
                'width': '180px',
                'sort': true
            },
            {
                'label': '要求签收时间',
                'prop': 'requestSignDate',
                'width': '180px',
                'sort': true
            },
            {
                'label': '上传时间',
                'prop': 'electronicTime',
                'width': '180px',
                'sort': true
            },
            {
                'label': '上传方式',
                'prop': 'receiptSourceText',
                'width': '120px',
                'sort': true
            },
            {
                'label': '物流单号',
                'prop': 'orderNo',
                'width': '180px',
                'sort': true
            },
            {
                'label': '运单号',
                'prop': 'waybillNo',
                'width': '180px',
                'sort': true
            },
            {
                'label': '业务模式',
                'prop': 'businessMode',
                'width': '120px',
                'sort': true
            },
            {
                'label': '承运商',
                'prop': 'carrierName',
                'width': '180px',
                'sort': true
            },
            {
                'label': '发车时间',
                'prop': 'actDepartTime',
                'width': '160px',
                'sort': true
            },
            {
                'label': '网配审核',
                'prop': 'netCheck',
                'width': '120px',
                'sort': true
            },
            {
                'label': '采购渠道',
                'prop': 'procurementChannelText',
                'width': '120px',
                'sort': true
            },
            {
                'label': '是否下发',
                'prop': 'carrierVisibleFlagName',
                'width': '120px',
                'sort': true

            },
            {
                'label': '收货单位',
                'prop': 'upperReceiverName',
                'width': '120px',
                'sort': true
            },
            {
                'label': '订单类型',
                'prop': 'orderTypeName',
                'width': '120px',
                'sort': true
            },
            {
                'label': '来源系统',
                'prop': 'sourceSystemName',
                'width': '120px',
                'sort': true
            },
            {
                'label': '任务类型',
                'prop': 'taskTypeName',
                'width': '120px',
                'sort': true
            },
            {
                'label': '签收类型',
                'prop': 'deliveredVerifyFlagName',
                'width': '120px',
                'sort': true
            },
            {
                'label': '签收方式',
                'prop': 'signTypeName',
                'optionNum': 'SIGN_TYPE',
                'width': '120px',
                'sort': true
            },
            {
                'label': '收货人地址',
                'prop': 'receiverDetailAddr',
                'width': '180px',
                'sort': true
            },
            {
                'label': '收货人固定电话',
                'prop': 'receiverTel',
                'width': '140px',
                'sort': true
            },
            {
                'label': '审批链接',
                'prop': 'iflowLinkName',
                'type': 'button',
                'width': '120px',
                'sort': true
            },
            {
                'label': '审批状态',
                'prop': 'iflowStatusName',
                'width': '120px',
                'sort': true
            },
            {
                'label': '分拨段号',
                'prop': 'distributionNum',
                'sort': true,
                'width': 120
            },
            {
                'label': '是否最后一段',
                'prop': 'distributionLastFlagName',
                'sort': true,
                'width': 130
            },
            {
                'label': '包件数',
                'prop': 'totalPkgQty',
                'sort': true,
                'width': 100
            },
            {
                'label': '是否代收',
                'prop': 'collectionFlagName',
                'sort': true,
                'width': 110
            },
            {
                'label': '运费类型',
                'prop': 'deliverypayTypeName',
                'sort': true,
                'width': 110
            },
            {
                'label': '货款收款状态',
                'prop': 'goodsFeeStatusName',
                'sort': true,
                'width': 130
            },
            {
                'label': '运费收款状态',
                'prop': 'transportFeeStatusName',
                'sort': true,
                'width': 130
            },
            {
                'label': '预约时间',
                'prop': 'appointmentTime',
                'sort': true,
                'width': 160
            },
            {
                'label': '期望送达时间',
                'prop': 'expectArriveEndTime',
                'sort': true,
                'width': 160
            },
            {
                'label': '报告审核状态',
                'prop': 'hongheFlagName',
                'sort': true,
                'width': 100
            },
            {
                label: '发货地市',
                prop: 'senderCityName',
                width: '120px'
            },
            {
                label: '发货地区',
                prop: 'senderDistrictName',
                width: '120px'
            },
            {
                label: '发货地乡镇',
                prop: 'senderTownName',
                width: '120px'
            },
            {
                label: '目的地市',
                prop: 'receiverCityName',
                width: '120px'
            },
            {
                label: '目的地区',
                prop: 'receiverDistrictName',
                width: '120px'
            },
            {
                label: '目的地乡镇',
                prop: 'receiverTownName',
                width: '120px'
            },
            {
                'label': '收货人',
                'prop': 'transReceiverName',
                'sort': true,
                'width': 130
            },
            {
                'label': '收货人电话',
                'prop': 'receiverTel',
                'sort': true,
                'width': 130
            },
            {
                'label': '收货人手机号码',
                'prop': 'receiverMobile',
                'sort': true,
                'width': 130
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '签收',
                'size': 'small',
                'event': 'view',
                'ifHas': 'otp04050007'
            },
            {
                'type': 'text',
                'label': '拒收',
                'size': 'small',
                'event': 'edit',
                'ifHas': 'otp04050008'
            },
            {
                'type': 'text',
                'label': '反查',
                'size': 'small',
                'event': 'recheck',
                'ifHas': '04050011'
            },
            {
                'type': 'text',
                'label': '鸿合回单',
                'size': 'small',
                'event': 'hongHe',
                'ifHas': '04050012'
            }
        ],
        'leftOperation': true,
        'leftWidth': 170
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50]
    },
    // 高级搜索配置项
    searchTotalTitle: [
        {
            name: '运输单号',
            value: 'taskNo',
            type: 'input'
        },
        {
            name: '合同号',
            value: 'contractNo',
            type: 'input'
        },
        {
            name: '物流单号',
            value: 'orderNo',
            type: 'input'
        },
        {
            name: '运单号',
            value: 'waybillNo',
            type: 'input'
        },
        {
            name: '订单号',
            value: 'orderNo',
            type: 'input'
        },
        {
            name: '客户',
            value: 'customerName',
            unfold: true,
            type: 'advance',
            advanceConfig: [
                { prop: 'ebcuNameCn', value: '名称' },
                { prop: 'pmCode', value: '编码' }
            ],
            tableConfig: [
                { prop: 'pmCode', value: '客户编码' },
                { prop: 'ebcuNameCn', value: '客户名称' }
            ],
            advanceUrl: '/ebCustomer/searchByEbCustomer',
            cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName']
        },
        {
            name: '服务平台',
            value: 'siteName',
            unfold: true,
            type: 'advance',
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '名称' },
                { prop: 'escoCompanyNo', value: '编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNo', value: '平台编码' },
                { prop: 'escoCompanyNameCn', value: '平台名称' }
            ],
            advanceUrl: '/searchPlatform',
            cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
        },
        {
            name: '上传方式',
            value: 'receiptSource',
            type: 'select',
            optionNum: 'SYS_TMS_UPLOAD_WAY',
            options: []
        },
        {
            name: '发货地市',
            value: 'senderCityName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地市名称' },
                { 'prop': 'ebplCode', 'value': '发货地市编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地市名称' },
                { 'prop': 'ebplCode', 'value': '发货地市编码' }
            ],
            cbParams: [
                'ebplCode#senderCityCode', 'ebplNameCn#senderCityName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY',
            advanceCode: 'senderCityCode'
        },
        {
            name: '发货地区',
            value: 'senderDistrictName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地区名称' },
                { 'prop': 'ebplCode', 'value': '发货地区编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地区名称' },
                { 'prop': 'ebplCode', 'value': '发货地区编码' }
            ],
            cbParams: [
                'ebplCode#senderDistrictCode', 'ebplNameCn#senderDistrictName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_DISTRICT',
            advanceCode: 'senderDistrictCode'
        },
        {
            name: '发货地乡镇',
            value: 'senderTownName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地乡镇名称' },
                { 'prop': 'ebplCode', 'value': '发货地乡镇编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地乡镇名称' },
                { 'prop': 'ebplCode', 'value': '发货地乡镇编码' }
            ],
            cbParams: [
                'ebplCode#senderTownCode', 'ebplNameCn#senderTownName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_STREET',
            advanceCode: 'senderTownCode'
        },
        {
            name: '目的地市',
            value: 'receiverCityName',
            type: 'advance',
            advanceConfig: [
                { prop: 'ebplNameCn', 'value': '目的地市名称' },
                { prop: 'ebplCode', 'value': '目的地市编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', 'value': '目的地省名称' },
                { prop: 'ebplCode', 'value': '目的地市编码' }
            ],
            cbParams: [
                'ebplCode#receiverCityCode',
                'ebplNameCn#receiverCityName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY',
            advanceCode: 'receiverCityCode'
        },
        {
            name: '目的地区',
            value: 'receiverDistrictName',
            type: 'advance',
            advanceConfig: [
                { prop: 'ebplNameCn', 'value': '目的地区名称' },
                { prop: 'ebplCode', 'value': '目的地区编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', 'value': '目的地区名称' },
                { prop: 'ebplCode', 'value': '目的地区编码' }
            ],
            cbParams: [
                'ebplCode#receiverDistrictCode',
                'ebplNameCn#receiverDistrictName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_DISTRICT',
            advanceCode: 'receiverDistrictCode'
        },
        {
            name: '目的地乡镇',
            value: 'receiverTownName',
            type: 'advance',
            advanceConfig: [
                { prop: 'ebplNameCn', 'value': '目的地乡镇名称' },
                { prop: 'ebplCode', 'value': '目的地乡镇编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', 'value': '目的地乡镇名称' },
                { prop: 'ebplCode', 'value': '目的地乡镇编码' }
            ],
            cbParams: [
                'ebplCode#receiverTownCode',
                'ebplNameCn#receiverTownName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_STREET',
            advanceCode: 'receiverTownCode'
        },
        {
            name: '是否完好',
            value: 'signIsFull',
            type: 'select',
            optionNum: 'signIsFull',
            options: []
        },
        {
            name: '项目分类',
            value: 'projectClassify',
            type: 'select',
            optionNum: 'PROJECT_CLASSIFY',
            options: []
        },
        {
            name: '业务模式',
            value: 'businessMode',
            type: 'select',
            optionNum: 'BUSINESS_MODE',
            options: []
        },
        {
            name: '发车单号',
            value: 'dispatchNo',
            type: 'input'
        },
        {
            'name': '要求签收时间',
            'value': 'signTime',
            'type': 'time',
            'timeNum': 0
        },
        {
            'name': '签收状态',
            'value': 'signStatus',
            'type': 'select',
            'optionNum': 'SIGN_STATUS',
            'multiple': true
        },
        {
            'name': '承运商',
            'advanceLabel': '承运商',
            'value': 'carrierName',
            'advanceConfig': [
                { 'prop': 'supplierNameCn', 'value': '承运商名称' },
                { 'prop': 'supplierCode', 'value': '承运商编码' }
            ],
            'tableConfig': [
                { 'prop': 'supplierNameCn', 'value': '承运商名称' },
                { 'prop': 'supplierCode', 'value': '承运商编码' },
                { prop: 'transNameListStr', value: '采购渠道' }
            ],
            advanceNotSearch: true,
            queryConditionRequired: true,
            method: 'post',
            prefix: '/api-tms',
            advanceUrl: '/srm/supplier/search',
            'type': 'advance',
            'cbParams': [
                'supplierNameCn#carrierName', 'supplierCode#carrierCode', 'transTypeListStr#transType', 'transNameListStr#tranName'
            ],
            'advanceCascade': 'supplierCode#carrierCode'
        },
        {
            name: '网配审核',
            value: 'isNetCheck',
            type: 'select',
            options: [
                { value: 'Y', label: '是' }, { value: 'N', label: '否' }
            ]
        },
        {
            'name': '采购渠道',
            'value': 'procurementChannel',
            'optionNum': 'OTP_TMS_PROCUREMENT_CHANNEL',
            'type': 'select'
        },
        {
            'name': '是否下发',
            'value': 'carrierVisibleFlag',
            'type': 'select',
            'options': [{ 'value': 'Y', 'label': '是' }, { 'value': 'N', 'label': '否' }]
        },
        {
            name: '收货单位',
            value: 'upperReceiverName',
            type: 'input'
        },
        {
            name: '集配单号',
            value: 'collectNo',
            type: 'input'
        },
        {
            name: '订单类型',
            value: 'orderType',
            type: 'select',
            optionNum: 'ORDER_TYPE',
            options: []
        },
        {
            name: '是否代收',
            value: 'collectionFlag',
            type: 'select',
            options: [
                { value: 'Y', label: '是' },
                { value: 'N', label: '否' }
            ]
        },
        {
            name: '运费类型',
            value: 'deliverypayType',
            type: 'select',
            options: [
                { value: 1, label: '寄付' },
                { value: 2, label: '到付' }
            ]
        },
        {
            name: '运费收款状态',
            value: 'transportFeeStatus',
            type: 'select',
            optionNum: 'OTP_TRANSPORT_FEE_STATUS',
            options: []
        },
        {
            name: '货款收款状态',
            value: 'goodsFeeStatus',
            type: 'select',
            optionNum: 'OTP_TRANSPORT_FEE_STATUS',
            options: []
        },
        {
            name: '来源系统',
            value: 'sourceSystem',
            optionNum: 'SOURCE_SYSTEM',
            type: 'select',
            options: []
        },
        {
            name: '任务类型',
            value: 'taskType',
            type: 'select',
            optionNum: 'TASK_TYPE',
            options: []
        },
        {
            name: '收货人',
            value: 'transReceiverName',
            type: 'input'
        },
        {
            name: '收货人电话',
            value: 'receiverTel',
            type: 'input'
        },
        {
            name: '收货人手机号码',
            value: 'receiverMobile',
            type: 'input'
        }
    ]
};
